import React from 'react';
import { Star } from 'lucide-react';

const StarRating = ({ count = 5, size = 18, className = '' }) => (
  <span className={`star-rating ${className}`.trim()} aria-hidden="true">
    {Array.from({ length: count }, (_, index) => (
      <Star
        key={index}
        size={size}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={1}
      />
    ))}
  </span>
);

export default StarRating;
